import { render, staticRenderFns } from "./ended.vue?vue&type=template&id=1e65dac6&scoped=true&"
import script from "./ended.vue?vue&type=script&lang=js&"
export * from "./ended.vue?vue&type=script&lang=js&"
import style0 from "./ended.vue?vue&type=style&index=0&id=1e65dac6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e65dac6",
  null
  
)

export default component.exports